// extracted by mini-css-extract-plugin
export var alignCenter = "_8w-d";
export var bannerShown = "_8w-6";
export var buttonContent = "_8w-0";
export var cardList = "_8w-1";
export var centerContent = "_8w-2";
export var chevron = "_8w-3";
export var closePanelButton = "_8w-k";
export var conversationContextContainer = "_8w-l";
export var conversationDetailContainer = "_8w-4";
export var detailWrapper = "_8w-7";
export var dropdownButton = "_8w-e";
export var dropdownTitle = "_8w-9";
export var fullHeight = "_8w-5";
export var hidden = "_8w-a";
export var icon = "_8w-b";
export var mergeSuggestionWrapper = "_8w-m";
export var panel = "_8w-i";
export var portalButtonsWrapper = "_8w-c";
export var right = "_8w-j";
export var tableSummaryContainer = "_8w-8";
export var tableSummaryHeader = "_8w-g";
export var threeDotsButton = "_8w-f";
export var wide = "_8w-h";